var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"my-4 text-center",attrs:{"fluid":""}},[_c('h2',{staticClass:"pt-4"},[_vm._v("Not Found")]),_c('p',{staticClass:"lead"},[_vm._v("This page does not exist.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }